/** Role retornada pela API v1/Role */
export interface Role {
  id: string;
  name: string;
  slug: string;
  description: string;
  isActive: boolean;
}

/** Parâmetros da requisição de listagem de roles */
export interface FetchRolesParams {
  /** Incluir roles inativos (default: false) */
  includeInactive?: boolean;
}

export type FetchRolesFn = (params?: FetchRolesParams) => Promise<Role[]>;

/** Cliente mínimo necessário para a chamada (get). Compatível com ApiClient do core. */
export interface RoleApiClient {
  get<T>(url: string): Promise<T>;
}

const ROLE_PATH = 'v1/Role';

/**
 * Cria o cliente de API de roles.
 * Recebe o api do app (b2b/b2b2c) e retorna { fetchRoles }.
 */
export function createRoleApi(api: RoleApiClient) {
  return {
    /**
     * Lista roles (GET v1/Role?includeInactive=false).
     * Aceita e aplica automaticamente Accept: text/plain e Accept-Language via cliente.
     */
    async fetchRoles(params?: FetchRolesParams): Promise<Role[]> {
      const includeInactive = params?.includeInactive ?? false;
      const query = new URLSearchParams();
      query.set('includeInactive', String(includeInactive));
      const url = `/${ROLE_PATH}?${query.toString()}`;

      try {
        const data = await api.get<Role[]>(url);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    },
  };
}

export type RoleApi = ReturnType<typeof createRoleApi>;
